import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import React from 'react';
import { Form, Input } from 'src/components/Antd';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import { getSetting, saveSetting } from 'src/request/settings/3rdPartyApi';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import Left from './Header/TopLeft';
import Right from './Header/TopRight';
import css from './css.module.less';

const formName = '3rdPartyApi';

const permissions = () => {
  const view_settings = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsThirdParty,
        operation: EnumOperation.view_settings,
      }),
    ],
  });
  const edit_setting = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsThirdParty,
        operation: EnumOperation.edit_setting,
      }),
    ],
  });
  return {
    view_settings,
    edit_setting,
  };
};

const ThirdPartySetting = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_settings, edit_setting } = permissions();
  const [form] = Form.useForm();
  const [hasModified, setHasModified] = React.useState(false);
  const [data, setData] = React.useState(null);
  React.useEffect(() => {
    if (view_settings) {
      getSetting().then((res) => {
        const { googleMapApiKey } = res;
        form.setFieldsValue({ googleMapApiKey });
        setData(res);
      });
    }
  }, []);
  const handleOnSubmit = (values) => {
    const d = { ...data, ...values };
    saveSetting(d).then((res) => {
      setData(res);
      setHasModified(false);
    });
  };
  const ele = [
    {
      child: (
        <SectionWrapper title={getI18n('thirdPartyAPI.index.googleMap')}>
          <div className={css.topTip}>
            {getI18n('thirdPartyAPI.index.topTip')}
          </div>
          {view_settings && (
            <Row
              elements={[
                {
                  child: (
                    <ItemWrapper
                      title={`${getI18n('thirdPartyAPI.index.aPIKey')}*`}>
                      <Input
                        size='large'
                        formProps={{
                          name: 'googleMapApiKey',
                          rules: [
                            {
                              required: true,
                              message: replaceI18nVariables(
                                getI18n('general.fieldisrequired'),
                                getI18n('thirdPartyAPI.index.aPIKey'),
                              ),
                            },
                          ],
                        }}
                        disabled={!edit_setting}
                      />
                    </ItemWrapper>
                  ),
                },
                {
                  child: <React.Fragment />,
                },
              ]}
            />
          )}
        </SectionWrapper>
      ),
    },
  ];

  return (
    <React.Fragment>
      <Form
        onFinish={handleOnSubmit}
        form={form}
        name={formName}
        onValuesChange={() => {
          setHasModified(true);
        }}>
        <Layout
          topLeft={<Left />}
          topRight={
            <Right
              hasModified={hasModified}
              onSubmit={() => {
                form.submit();
              }}
            />
          }
          elements={ele}
        />
      </Form>
    </React.Fragment>
  );
};
export default ThirdPartySetting;
